import { useEffect, useRef } from "react";

const clamp01 = (v) => Math.min(1, Math.max(0, v));

// Scroll-driven "depth exit" sans framer-motion : quand la section quitte le viewport,
// elle rétrécit, bascule en 3D et s'assombrit — la suivante la recouvre.
export default function SectionFX({ children, className = "", cvAuto = false }) {
  const ref = useRef(null);
  const inner = useRef(null);

  useEffect(() => {
    const el = ref.current;
    const node = inner.current;
    if (!el || !node) return;
    let raf = 0;
    let last = -1;
    const update = () => {
      raf = 0;
      const r = el.getBoundingClientRect();
      const vh = window.innerHeight;
      const p = clamp01((vh - r.bottom) / vh);
      if (p === last) return;
      last = p;
      const scale = 1 - 0.07 * p;
      const opacity = 1 - 0.65 * clamp01(p / 0.85);
      node.style.transform = `perspective(1400px) rotateX(${4 * p}deg) scale(${scale})`;
      node.style.opacity = opacity;
    };
    const onScroll = () => {
      if (!raf) raf = requestAnimationFrame(update);
    };
    update();
    window.addEventListener("scroll", onScroll, { passive: true });
    window.addEventListener("resize", onScroll);
    return () => {
      window.removeEventListener("scroll", onScroll);
      window.removeEventListener("resize", onScroll);
      if (raf) cancelAnimationFrame(raf);
    };
  }, []);

  // cvAuto : active `content-visibility: auto` sur les sections below-the-fold
  return (
    <div ref={ref} className={`relative ${className}`} {...(cvAuto ? { "data-cv-auto": "" } : {})}>
      <div ref={inner} style={{ transformOrigin: "center top" }}>
        {children}
      </div>
    </div>
  );
}
